'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUnauthorizedResponse;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUnauthorizedResponse(apiError) {
  return ((0, _get2.default)(apiError, 'response.status') || apiError.statusCode) === 401;
}
//# sourceMappingURL=isUnauthorizedResponse.js.map